(function () {
  if (typeof window.ElsPreOrder !== 'undefined') {
    var template = window.ElsPreOrder.template;
    var isOnlyCustomer = window.ElsPreOrder.isOnlyCustomer;
    var customer = window.ElsPreOrder.customer;

    if (template === 'cart') {
      var checkOutButton = document.querySelector('#cart_form [name="checkout"]');
      var cart = window.ElsPreOrder.cart;

      if (checkOutButton && cart) {
        var soldOutItem = null;
        cart.forEach(function (item) {
          if (!item.isPossibleBuy) {
            soldOutItem = item;
            return false;
          }
        });

        checkOutButton.addEventListener('mousedown', onClickCheckOutButton);
        checkOutButton.addEventListener('touchstart', onClickCheckOutButton);

        function onClickCheckOutButton(e) {
          if (soldOutItem) {
            e.preventDefault();
            alert(soldOutItem.title + " has not enough items in stock.\nPlease reduce the quantity or remove it from the cart.")
          }
        }
      }
    } else if (template === 'product') {
      window.ElsPreOrder.getPrepareVariant = getPrepareVariant;
      window.ElsPreOrder.renderPreOrderButton = renderPreOrderButton;
      window.ElsPreOrder.isEnable = isEnable();
      var shipments = (typeof window.ElsPreOrder.shipments !== 'undefined') && window.ElsPreOrder.shipments ? window.ElsPreOrder.shipments : [],
        variants = (typeof window.ElsPreOrder.variants !== 'undefined') && window.ElsPreOrder.variants ? window.ElsPreOrder.variants : [],
        defaultMessage = 'Estimated to Ship on',
        messageWasAdded = false,
        form = document.querySelector('.shopify-product-form'),
        messageContainer = document.querySelector('.shopify-product-form .purchase-details');
    }

    /**
     *
     * @param variant
     * @returns {*}
     */
    function getPrepareVariant(variant) {
      var currentVariant = variants.find(function (v) {
        return +v.id === +variant.id
      });
      var quantity = currentVariant ? currentVariant.inventory_quantity : variant.inventory_quantity;


      if (variant.inventory_management === 'shopify'
        && variant.inventory_policy === 'continue'
        && quantity <= 0
        && shipments
        && typeof shipments[variant.id] !== 'undefined'
        && shipments[variant.id].length > 0) {
        var commonQuantity = getCommonQuantityByVariant(variant);
        variant.inventory_quantity = commonQuantity;
        if (commonQuantity > 0) {
          variant.available = true;
          variant.preorder = true;
          if (isOnlyCustomer && (typeof customer == 'undefined' || (customer && !customer.isSpecial))) {
            variant.available = false;
            variant.preorder = false;
          }
        } else {
          variant.available = false;
        }
      }
      return variant;
    }

    /**
     *
     * @param variant
     */
    function renderPreOrderButton(variant) {
      if (variant.hasOwnProperty('preorder')
        && variant.preorder
        && shipments
        && typeof shipments[variant.id] !== 'undefined'
        && shipments[variant.id].length > 0) {
        var atcButtons = document.querySelectorAll('.shopify-product-form .add_to_cart');
        var variantShipment = getShipment(variant);
        var message = getMessage(variantShipment);
        atcButtons.forEach(function (atc) {
          atc.classList.remove('disabled');
          atc.removeAttribute('disabled');
          atc.querySelector('span:first-child').innerText = 'Pre Order';
          atc.parentNode.classList.remove('product-is-unavailable');
          renderMessage('Preorder: ' + message, true);
          renderProperties([
            {
              key: 'Preorder',
              value: message,
            },
            {
              key: 'Shipment',
              value: getPOname(variantShipment)
            }
          ]);
        })
      } else {
        renderMessage('', false);
        renderProperties();
      }
    }

    /**
     *
     * @param variant
     * @returns {undefined}
     */
    function getCommonQuantityByVariant(variant) {
      var currentVariant = variants.find(function (v) {
        return +v.id === +variant.id
      });
      var quantity = currentVariant ? currentVariant.inventory_quantity : variant.inventory_quantity;
      var shipments = (typeof window.ElsPreOrder.shipments !== 'undefined') && window.ElsPreOrder.shipments ? window.ElsPreOrder.shipments : [];
      if (typeof shipments[variant.id] !== 'undefined') {
        shipments[variant.id].forEach(function (shipment) {
          quantity += shipment.quantity;
        });
      }
      return quantity;
    }

    /**
     *
     * @param shipment
     * @returns {string}
     */
    function getMessage(shipment) {
      var message = '';
      if (shipment) {
        message = shipment.message ? shipment.message : defaultMessage + ' ' + shipment.eta_at;
      }
      return message;
    }

    /**
     *
     * @param shipment
     * @returns {string}
     */
    function getPOname(shipment) {
      var name = '';
      if (shipment) {
        name = typeof shipment.po_name !== 'undefined' ? shipment.po_name : shipment.message ? shipment.message : defaultMessage + ' ' + shipment.eta_at;
      }
      return name;
    }

    /**
     *
     * @param variant
     * @returns {null|*}
     */
    function getShipment(variant) {
      var variantShipments = shipments[variant.id];
      if (typeof variantShipments !== 'undefined') {
        var currentVariant = variants.find(function (v) {
          return +v.id === +variant.id
        });
        var quantity = currentVariant ? currentVariant.inventory_quantity : variant.inventory_quantity;
        for (var variantId in variantShipments) {
          if (variantShipments.hasOwnProperty(variantId)) {
            quantity += variantShipments[variantId].quantity;
            if (quantity > 0) {
              return variantShipments[variantId];
            }
          }
        }
      }
      return null;
    }

    /**
     *
     * @param message
     * @param visible
     */
    function renderMessage(message, visible) {
      if (messageWasAdded) {
        var messageTextContainer = messageContainer.querySelector('[data-pre-order-message]');
        messageTextContainer.style.display = visible ? 'block' : 'none';
        messageTextContainer.innerText = message;
      } else {
        var style = 'width: 100%; font-weight: bold; margin-top: 20px; display:' + (visible ? 'block' : 'none');
        messageContainer.insertAdjacentHTML('beforeEnd', '<span data-pre-order-message style="' + style + '">' + message + '</span>');
        messageWasAdded = true;
      }
    }

    /**
     *
     * @param properties
     */
    function renderProperties(properties) {
      var inputs = form.querySelectorAll('[data-pre-order-property]');
      inputs.forEach(function (input) {
        form.removeChild(input);
      });
      if (typeof properties !== 'undefined' && properties.length > 0) {
        properties.forEach(function (property) {
          form.insertAdjacentHTML('beforeEnd', '<input data-pre-order-property type="hidden" name="properties[' + property.key + ']" value="' + property.value + '">');
        });
      }
    }

    /**
     *
     * @returns {*}
     */
    function isEnable() {
      return isOnlyCustomer ? customer && customer.isSpecial : true;
    }
  }
}());